export const navigationMenuButtonLabel = "F4paqd";
export const settingsDividerText = "THawc";
export default {navigationMenuButtonLabel,settingsDividerText};